import React from "react";
import { Modal, Button } from "react-bootstrap";
import { weekDays } from "../../utils";

const BookingConfirmationModal = ({ show, onClose, booking }) => {
  return (
    <Modal show={show} onHide={onClose} centered>
      <Modal.Header closeButton>
        <Modal.Title>
          {booking?.updated ? "Booking Updated" : "Booking Confirmed"}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <h5>
          Your booking has been successfully{" "}
          {booking?.updated ? "updated" : "created"}!
        </h5>
        <p>
          <strong>Room:</strong> {booking?.room.name}
        </p>
        <p>
          <strong>Date:</strong> {booking?.date}
        </p>
        <p>
          <strong>Time:</strong> {booking?.startTime} - {booking?.endTime}
        </p>
        <p>
          <strong>Purpose:</strong> {booking?.purpose}
        </p>
        <p>
          <strong>Booked by:</strong> {booking?.name} ({booking?.email})
        </p>
        {booking?.isRecurring && (
          <>
            <p>
              <strong>Recurrence:</strong> {booking?.recurrenceType}
            </p>
            {booking?.recurrenceType === "weekly" && (
              <p>
                <strong>Days:</strong>{" "}
                {booking?.recurrenceDays
                  .map((id) => weekDays.find((day) => day.id === id)?.name)
                  .join(", ")}
              </p>
            )}
            <p>
              <strong>Until:</strong> {booking?.recurrenceEndDate}
            </p>
          </>
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="primary" onClick={onClose}>
          OK
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default BookingConfirmationModal;
